import { createTheme } from '@mui/material/styles';

export const colors = {
    blue: '#3b82f6',
    blueDark: '#1e3a8a',
    blueLight: '#93c5fd',
    green: '#34d399',
    dark: '#0f172a',
    panel: '#1e293b',
    textLight: '#e0f2fe',
    mutedLight: '#93c5fd',
    line: 'rgba(59, 130, 246, 0.2)',
};

export const pagePadding = {
    px: { xs: 2, sm: 3, md: 5, lg: 7 },
};

export const getLandingTheme = () =>
    createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: colors.blue,
                dark: colors.blueDark,
                light: colors.blueLight,
                contrastText: '#ffffff',
            },
            secondary: {
                main: colors.green,
                contrastText: '#ffffff',
            },
            background: {
                default: colors.dark,
                paper: colors.panel,
            },
            text: {
                primary: colors.textLight,
                secondary: colors.mutedLight,
            },
        },
        typography: {
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
            h1: {
                fontWeight: 700,
                lineHeight: 1.02,
                letterSpacing: 0,
                fontSize: '3rem',
                '@media (min-width:600px)': {
                    fontSize: '4.7rem',
                },
                '@media (min-width:1200px)': {
                    fontSize: '6.2rem',
                },
            },
            h2: {
                fontWeight: 700,
                lineHeight: 1.08,
                letterSpacing: 0,
                fontSize: '2.1rem',
                '@media (min-width:900px)': {
                    fontSize: '3.25rem',
                },
            },
            button: {
                textTransform: 'none',
                fontWeight: 600,
            },
        },
        shape: {
            borderRadius: 18,
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        minHeight: 44,
                        borderRadius: 999,
                        boxShadow: 'none',
                    },
                    contained: {
                        background: colors.blue,
                        '&:hover': {
                            background: '#2563eb',
                            boxShadow: 'none',
                        },
                    },
                },
            },
        },
    });
